import { useEffect, useState } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};
const agentService = {
  _url: process.env.REACT_APP_AGENT_API_URL,
  _model_url: process.env.REACT_APP_MODEL_API_URL,
  _feeda_url: process.env.REACT_APP_FEEDA_API_URL,
  _promopt_url: process.env.REACT_APP_PROMOT_API_URL,
  _main_url: process.env.REACT_APP_AUTH_API_URL,

  GetAgentList(searchQuery, fetch) {
    const [data, setsData] = useState({
      sessions: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllAgent(searchQuery))
        .then(res => {
          setsData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [searchQuery, fetch]);

    return {
      _loading: status === STATUS.LOADING,
      _error: status === STATUS.ERROR,
      _data: data,
    };
  },

  async createAgent(payload) {
    return await Fetch.post(`${this._url}/create`, payload);
  },
  async EditAgent(payload) {
    return await Fetch.put(`${this._url}/update`, payload);
  },
  async getAgentDetail(payload) {
    return await Fetch.get(`${this._url}/details?agent_id=${payload}`);
  },
  async deleteAgent(payload) {
    return await Fetch.delete(`${this._url}/delete?agent_id=${payload}`);
  },
  async getAllAgent() {
    return await Fetch.get(`${this._url}/list?agent_type=user_created&domain_id=48b1550d-081b-4328-8d69-d30191d619c0`);
  },
  async getAllModels() {
    return await Fetch.get(`${this._model_url}/list`);
  },

  async getAllfeedaAgentsCategory(domain_type) {
    const type = domain_type ? `?domain_type=${domain_type}` : ``;
    return await Fetch.get(`${this._main_url}/domain/list${type}`);
  },

  GetFeedaAgents(searchQuery, fetch) {
    const [feedaAgentData, setfeedaAgentData] = useState({
      sessions: [],
      totalItems: 0,
    });
    const { cancellablePromise } = useCancellablePromise();
    const [status, setStatus] = useState(STATUS.LOADING);
    useEffect(() => {
      setStatus(STATUS.LOADING);
      cancellablePromise(this.getAllfeedaAgents(searchQuery))
        .then(res => {
          setfeedaAgentData(() => res);
          setStatus(STATUS.SUCCESS);
        })
        .catch(() => setStatus(STATUS.ERROR));
    }, [searchQuery, fetch]);

    return {
      agent_loading: status === STATUS.LOADING,
      agent_error: status === STATUS.ERROR,
      agent_data: feedaAgentData,
    };
  },
  async getAllfeedaAgents(domain_id = '') {
    return await Fetch.get(`${this._url}/list?agent_type=admin_created&domain_id=48b1550d-081b-4328-8d69-d30191d619c0`);
  },
  async generatePrompt(payload) {
    return await Fetch.post(`${this._promopt_url}/generate?data=${payload}`);
  },
  async generateDomain(payload) {
    return await Fetch.post(`${this._main_url}/domain/create`, payload);
  },
};

export default agentService;
